<template>
  <div class="row ">
    <div class="col-lg-5">
      <section class="card" style="margin-top: 30px">
        <form class="p-5" id="myCat">
          <div class="col-md-12">
            <label class="form-label p-2  ">شناسه</label>
            <a href="#" data-toggle="popover" class="popover-toggle"
               title="منظور از شناسه محصول در ووکامرس، این است که شما باید به پنل وردپرس بروید و در بخش لیست محصولات در ووکامرس، در قسمت عنوان محصول، یک شناسه و کد وجود دارد. شما باید این کد را به عنوان شناسه محصول ایجاد و تعریف کنید. این شناسه مشخص می‌کند که این امتحان متعلق به آن محصول است.">
              <i class="fa fa-question" style="font-size: 10px; color:red"></i> </a>
            <input type="text" class="form-control" v-model="categorios.id"
                   :disabled="disabled" placeholder="لطفا فقط اعداد وارد کنید"
                   onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))">
          </div>
          <div class=" p-2 col-md-12 ">
            <label class="form-label m-2">عنوان</label>
            <input type="text" class="form-control" v-model="categorios.title">
          </div>


          <div class=" p-2 col-md-12 ">
            <label class="form-label m-2">لطفا نوع گواهینامه را تعیین کنید</label>
            <select id="" v-model="categorios.exam" class="form-select text-center ">
              <option value="">{{
                  (categorios.exam == 'true') ? نقدی : (categorios.exam == 'false') ? رایگان : ""
                }}
              </option>
              <option value="true">نقدی</option>
              <option value="false">رایگان</option>
            </select>
          </div>
          <div class="col-md-12 p-2">
            <div class="d-flex text-center">
              <div class="p-2 col-lg-4">
                <label class="form-label ">تعداد سوالات</label>
                <select v-model="categorios.count" class="form-control text ">
                  <option v-for="i in 300" :value="i">{{ i }}</option>
                </select>
              </div>
              <div class="p-2 col-lg-4">
                <label class="form-label">دقیقه</label>
                <select v-model="minutes" class="form-control col-lg-3 text-center ">
                  <option v-for="item in 59" :value="item">{{ (item <= 9) ? '0' + item : item }}</option>
                </select>
              </div>
              <div class="p-2 col-lg-4">
                <label class="form-label">ثانیه</label>
                <select v-model="seconds" class="form-control col-lg-3 text-center ">
                  <option  value="00">00</option>
                  <option v-for="item in 59" :value="(item <=9)?  '0'+ item : item">{{
                      (item <= 9) ? '0' + item : item
                    }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="p-2 col-md-12">

            <label class="form-label">شرط قبولی در آزمون</label>
            <select id="" v-model="categorios.acceptance" class="form-select text-center">
              <option v-for="i in 10" :value=i> ٪{{ i }}0</option>
            </select>
          </div>
          <div class="p-2  col-md-12">
            <label class="form-label">عنوان گواهینامه</label>
            <input type="text" class="form-control" v-model="categorios.text"
                   placeholder="عنوان که در گواهینامه میخواهید نمایش داده شود">
          </div>
          <div class="col-md-12">
            <label class="form-label">سطح</label>
            <select id="" v-model="categorios.level" class="form-select text-center ">
              <option value="">{{
                  (categorios.level === 'medium') ? selectOption.medium : (categorios.level === 'preliminary') ? selectOption.preliminary : (categorios.level === 'hard') ? selectOption.hard : text
                }}
              </option>
              <option value="preliminary">{{ selectOption.preliminary }}</option>
              <option value="medium">{{ selectOption.medium }}</option>
              <option value="hard">{{ selectOption.hard }}</option>
            </select>

            <div class=" p-2  col-md-12">
              <label class="form-label">وضعیت دسته</label>
              <select id="" v-model="categorios.status" class="form-select text-center  ">
                <option value="">{{
                    (categorios.status ? (categorios.status === 'true') ? selectOption.true : selectOption.false : text)
                  }}
                </option>
                <option value="true">{{ selectOption.true }}</option>
                <option value="false">{{ selectOption.false }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-12 p-3 ">
            <btn_loading v-if="loading"></btn_loading>
            <button type="button" v-elseif="loading=='false'" v-show="btn_insert" class="btn btn-success form-control"
                    @click="btn_create()"> ثبت
            </button>

            <button type="reset" v-elseif="loading=='false'" v-show="btn_up" class="btn btn-danger form-control"
                    @click="btn_update()">
              به روز رسانی
            </button>
          </div>
        </form>
      </section>
    </div>
    <div class="col-lg-7" style="margin-top: 30px">
      <section style="margin-top: 5px" class="card">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">شناسه</th>
            <th scope="col">عنوان</th>
            <th scope="col">عنوان گواهینامه</th>
            <th scope="col">سطح</th>
            <th scope="col">تعداد سوالات</th>
            <th scope="col">مدت زمان آزمون</th>
            <td scope="col">قبول آزمون</td>
            <th scope="col">وضیعت</th>
            <th scope="col">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for=" (list , index) in listCat">
            <td v-html="index +1"></td>
            <td v-html="list.id"></td>
            <td v-html="list.title"></td>
            <td v-html="list.text"></td>
            <td v-html="(list.level === 'medium')? selectOption.medium  : (list.level === 'preliminary') ? selectOption.preliminary : selectOption.hard "></td>
            <td v-html="list.count"></td>
            <td v-html="list.date"></td>
            <td v-html="list.acceptance"></td>
            <td v-html="  (list.status === 'true') ? selectOption.true : selectOption.false "></td>
            <td>
              <a href="#">
                <i class="fa fa-trash  text-danger " @click="btn_delete(list.id)"></i>
              </a>
              |
              <a href="#">
                <i class="fa fa-edit"
                   @click="btn_edit(list.title ,list.text ,list.level,list.status , list.id , list.date ,  list.count , 'false',list.exam ,list.acceptance)"></i>
              </a>
            </td>

          </tr>
           <tr>
             <td colspan="10">
               <nav class="text-danger">
                 <ul class="pagination  " style="justify-content: center;">
                   <li class="page-item">
                     <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                             v-on:click="foreachPaginateUsers(paginatetion.first_page_url)" title="اولین"><i
                         class="fa fa-angle-double-right"></i></button>
                     <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                             v-on:click="foreachPaginateUsers(paginatetion.prev_page_url)" title="قبلی"><i
                         class="fa fa-angle-right"></i></button>
                   </li>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   <li class="page-item">
                     <button class="btn btn-light" v-on:click="foreachPaginateUsers(paginatetion.next_page_url)"
                             :disabled="!paginatetion.next_page_url" title="بعدی">
                       <i class="fa fa-angle-left"></i></button>

                     <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                             v-on:click="foreachPaginateUsers(paginatetion.last_page_url)" title="اخرین"><i
                         class="fa fa-angle-double-left"></i></button>
                   </li>
                 </ul>
               </nav>
             </td>
           </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import config from "../../../../config/config.json";
import {useToast} from "vue-toastification";
import Btn_loading from "@/common/components/btn_loading.vue";
import {cats} from "@/panel/mixins/cats"
import lang from "@/langs/fa.json"
import axios from "axios";

export default {
  name: "index",
  components: {Btn_loading},
  mixins: [cats],
  created() {
    this.getCat()
  },
  methods: {
    makePaginatetion(data) {
      let self = this;
      let paginatetion = {
        current_page: data.current_page,
        last_page_url: data.last_page_url,
        next_page_url: data.next_page_url,
        prev_page_url: data.prev_page_url,
        first_page_url: data.first_page_url

      }
      self.paginatetion = paginatetion;
    },
    foreachPaginateUsers(url) {
      let self = this;
      self.url = url;
      self.getCat()
    },
    getCat: function () {
      let self = this;
      axios.get(self.url)
          .then(function (res) {
            self.listCat = res.data.data.data;
            self.makePaginatetion(res.data.data);
          })
          .catch(function (error) {
            return reject(error)
          });
    },

    btn_delete: function (id) {
      let self = this;
      self.$store.dispatch('btn_delete', `${self.url}/delete/${id}`)
      self.getCat()
    },
    btn_create: function () {
      let self = this;
      self.loading = true;
      const toast = useToast();
      let formData = new FormData();
      formData.append('id', self.categorios.id);
      formData.append('title', self.categorios.title);
      formData.append('text', self.categorios.text);
      formData.append('level', self.categorios.level);
      formData.append('status', self.categorios.status);
      formData.append('exam', self.categorios.exam);
      formData.append('date', self.minutes + ':' + self.seconds);
      formData.append('count', self.categorios.count);
      formData.append('acceptance', self.categorios.acceptance + '0');
      self.axios.post(self.url, formData).then(function (res) {
        if (res.data.status === 'true') {
          self.loading = false;
          self.btn_edit(" ", " ", " ", " ", "", " ", " ");
          self.btn_up = false;
          self.btn_insert = true;
          self.getCat();
          toast.success(res.data.messages);
          return "";
        }
      })
          .catch(function (errors) {
            self.loading = false;
            self.btn_up = false;
            self.btn_insert = true;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },
    btn_edit: function (title, text, level, status, id, date, count, disabled, exam, acceptance) {
      let self = this;
      self.btn_up = true;
      self.btn_insert = false;
      self.categorios.id = id;
      self.categorios.acceptance = acceptance;
      self.categorios.title = title;
      self.categorios.text = text;
      self.categorios.level = level;
      self.categorios.status = status;
      self.categorios.exam = exam;
      self.seconds = date.substr(3, 2);
      self.minutes = date.substr(0, 2);
      self.categorios.count = count;
      self.disabled = disabled;
    },
    btn_update: function () {
      let self = this;
      self.loading = true;
      const toast = useToast();
      self.btn_up = false;
      self.btn_insert = true;
      let formData = new FormData();
      formData.append('title', self.categorios.title);
      formData.append('text', self.categorios.text);
      formData.append('level', self.categorios.level);
      formData.append('status', self.categorios.status);
      formData.append('id', self.categorios.id);
      formData.append('exam', self.categorios.exam);
      formData.append('date', self.minutes + ':' + self.seconds);
      formData.append('count', self.categorios.count);
      formData.append('acceptance', self.categorios.acceptance + '0');

      self.axios.post(`${self.url}/update`,
          formData,
          {
            headers: {
              Accept: "application/json",
              responseType: "json",
            }
          }
      ).then(function (res) {
        self.loading = false;
        if (res.data.status === 'true') {
          self.btn_edit(" ", " ", " ", " ", "", " ", " ", false, "");
          self.getCat();
          toast.success(res.data.messages);
          self.btn_up = false;
          self.btn_insert = true;
          return "";
        }
      })
          .catch(function (errors) {
            self.btn_up = false;
            self.btn_insert = true;
            self.loading = false;
            self.disabled = false;
            if (errors.response.status === 422) {
              Object.values(errors.response.data.errors).forEach(function (val, key) {
                toast.error(val[0]);
              });
            }
            if (errors.response.status === 404) {
              toast.error(errors.response.data.messages);
            }
          });
    },
  }

}
</script>

<style scoped>

</style>